// extracted by mini-css-extract-plugin
export default {"speakericon":"talkeasy_speakericon__9HaRS","wave":"talkeasy_wave__u+Oug"};